export default {"src":"/_next/static/media/list.bab8ec7e.svg","height":64,"width":64};